import React, { useEffect, useState } from 'react';
import { Route, NavLink } from 'react-router-dom';

import Project from './Project';
import { Container, Search, Card, Grid, Image, Segment, Header, Message, Button, Icon, Sidebar, Menu } from 'semantic-ui-react'

import { MyStore } from '../../../../services/Store'
 
import MetaPanel from './MetaPanel'
 
import PatientProject from './PatientProject'
 
import Chats from "../messages/Chats";

 
const ChatView = (props) => {
 
  const [state, setState] = useState({
    activeConvoId: null,
    animation: 'overlay',
    direction: 'left',
    dimmed: false,
    visible: true,

    metaPanelVisible: false,
    metaPanelDirection: 'right',
    metaPanelAnimation: 'overlay',

    bothPanel: false


  })



  const [groupChats, setGroupChats] = useState({chats:[]})
  const currentUser = MyStore.auth().currentUser
  const [cards, setCards] = useState()
  const [currentGroup, setCurrentGroup] = useState()

  const [currentProjectChats, setCurrentProjectChats] = useState()
  const [logId, setLogId] = useState()
  // const [cardId, setCardId] = useState()

 
  // const groupId = props.oid
  // const groupsRef = MyStore.database().ref("groups").child(groupId)
  // const usersRef= MyStore.database().ref("users")

  // const mbrProjectsRef= MyStore.database().ref("groups").child(groupId).child('mbrprojects').child(currentUser.uid)

  const groupsRef2 = MyStore.database().ref("groups") 

  // const chatsRef =MyStore.database().ref("groups").child(groupId).child('chats')

  // const loadGroups = () => {
 
  //   if (props.oid) {
  //     MyStore.auth().onAuthStateChanged((currentUser) => {
  //       if (currentUser) {
  //         console.log('inside if')
  //         groupsRef2.child(props.oid).child('cards').once("value", snap => {
  //           let myArr = []
  //           for (const key in snap.val()) {
  //             myArr.push(Object.assign({}, snap.val()[key]));
  //           }
  //           if (snap.val() != null) {
  //             setCards(
  //               myArr

  //             );
  //             // () => this.setFirstGroup()
  //           }
  //           else {
  //             setCards([])
  //           }
  //         })

  //           .catch(error => {
  //             console.error(error);
  //           });

  //       }
  //     })
  //   }
  // }


//   const loadGroups2 = () => {
//     // const { groupsRef } = this.state;
//     // console.log(props)
//     if (props.oid) {
//       MyStore.auth().onAuthStateChanged((currentUser) => {
//         if (currentUser) {
//     const loadedGroups = [];
//         mbrProjectsRef.child('cards')
//         .on("child_added", snap => {
//             let cardId = snap.val().id;
//             groupsRef.child('cards').child(cardId).once("value", snap => {
//                 loadedGroups.push(Object.assign({}, snap.val()));
//             });
//                      console.log(loadedGroups)
//                      setGroupChats({chats:loadedGroups })
//             if (snap.val() == null) {
//               setGroupChats({chats: []})
   
//           }
 
//         });

//         }
//       })
//     }
//   }


//   const addGroupListener = () => {
    
 
//     if(currentUser){
 
//         const loadedGroups = [];
//         mbrProjectsRef.child('cards')
//         .on("child_added", snap => {
//             let cardId = snap.val().id;
//             console.log(cardId)

     
//             /**
//              * Get info from groups ref by group id in users ref
//              * and add it to our loaded groups in state
//              */
       
//             groupsRef.child('cards').child(cardId).once("value", snap => {
            
//               // for (const key in snap.val()) {
//                 loadedGroups.push(Object.assign({}, snap.val()));
//                 // console.log(snap.val()[key])
//                 // console.log(snap.val())
//               // }
 
            

              
//                 // loadedGroups.push(snap.val());
//                 console.log(snap.val())
//                 // this.setGroupChats(
//                 //     {
//                 //          loadedGroups
//                 //     },
//                 //     // () => this.setFirstGroup()
//                 // );





//             });
//             if (snap.val() != null) {
//               // users = myArr
//               // cg = myArr/
//               console.log('--- inside line 145 --')
//               setGroupChats(loadGroups)
//               console.log(loadGroups)
  
//               // console.log(myArr)
//               // setState({myArr})
//           }
//             // addNotificationListener(groupId, false);
//         });
//     }
//     else{
//         return
//     }

// };



  useEffect(() => {

    // console.log(props)
    
 

    // console.log('---------- currentKey ------------------ ')
   
    // console.log(' ----line 159  ')



  }, [currentGroup])

 
  const handleLeftSidebar = (boolVal) => () =>
    setState({ visible: boolVal })



  const handleRightSidebar = (boolVal) => () =>
    setState({ metaPanelVisible: boolVal })




  const handleBothPanels = (boolVal) => () =>
    setState({ metaPanelVisible: boolVal, visible: boolVal, bothPanel: boolVal })
 


  // const displayProjects = (projects) => {
  //   if (projects) {
  //     console.log(projects)
  //     return (
  //       Array.from(projects.keys()).map(key => (
  //         <Project
  //           item={projects[key]}
  //           key={projects[key].cardId}
  //           image={projects[key].downloadURL}
  //           heading={projects[key].heading}
  //           title={projects[key].title}
  //           text={projects[key].text}
  //           id={projects[key].id}
  //           description={projects[key].description}
  //         />
  //       ))
  //     )
  //   }
  // }

 


  const changeGroup = group => {
    // const groups = MyStore.database().ref("groups").child('-LwLokoEOlo2jFZHUsDJ')
    // console.log('----------- groups  current group -------------')
 
    // console.log('after setstate current group')
    // console.log(currentGroup)
 

    setCurrentGroup(group)

 
    if(currentGroup !== group){
      setCurrentProjectChats(group)
    }

 
    setLogId(group.logsGroupId)
    // console.log(group.logsGroupId)

 

  };




  const ButtonMultipleConditionals = () => {

    const showMetaPanelBool = !state.metaPanelVisible
    const showChatsBool = !state.visible
    const bothPanels = !state.bothPanel

 
    return (

      <div style={{
        textAlign: "center",
        background: 'transparent'
      }}>

        <Button
          color='green' size='large' inverted
          // onClick={handleAnimationChange('slide out')}
          onClick={handleLeftSidebar(showChatsBool)}
        ><Icon name='chat' /> projects</Button>


        <Button color='purple' size='large' inverted onClick={handleRightSidebar(showMetaPanelBool)}>
          <Icon name='setting' />
          details
              </Button>


        <Button color='black' inverted size='large' onClick={handleBothPanels(bothPanels)}>
          <Icon name='chat' color='green' />
          <Icon name='setting' color='purple' />
        </Button>


      </div>
    )
  }

  // handleBoth

  const SegmentPadded = () =>

    <Segment style={{
      margin: 'center',
      // background: "transparent",
      border: "0px solid transparent",
      blackground: 'transparent',
      boxShadow: "none",
      padding: '0px',
    }}>

      {ButtonMultipleConditionals()}



    </Segment>



  const VerticalSidebar = ({ animation, direction, visible }) => (
    <Sidebar
      as={Menu}
      animation={animation}
      direction={direction}
      //   icon='labeled'
      // inverted
      // vertical
      visible={visible}
    >

  <PatientProject 
          currentUser={currentUser}
          currentGroup={currentGroup}
          activeConvoId={state.activeConvoId}
          changeGroup={changeGroup}
          oid = {props.oid}
      />

      {/* <Group
        currentUser={currentUser}
        currentGroup={currentGroup}
        activeConvoId={state.activeConvoId}
        changeGroup={changeGroup}
      // addNotificationListener={this.addNotificationListener}
      // notifications={notifications}
      /> */}

      


    </Sidebar>
  )




  const MetaPanelSidebar = ({ animation, direction, visible }) => (
    <Sidebar
      as={Segment}
      animation={animation}
      direction={direction}
      //   icon='labeled'
      // inverted
      // vertical
      visible={visible}
    // id='sbChatProjects'
    // className="sbChatProjects"


    >
      {/* 
      <Group
        currentUser={currentUser}
        currentGroup={currentGroup}
        activeConvoId={state.activeConvoId}
        changeGroup={changeGroup}
      /> */}

      <MetaPanel
        currentGroup={currentGroup}
        currentUser={''}
        isDM={false}
        leaders={currentGroup.memebers}
      />


    </Sidebar>
  )





  // console.log(state.metaPanelVisible)
  // console.log(state.visible)
  return (
    <React.Fragment>

      <div >
        {SegmentPadded()}


        <Sidebar.Pushable as={Segment}

          style={{ border: "0px solid transparent", margin: 'justified' }}
        >



          {state.visible ? (
            <VerticalSidebar
              animation='overlay'
              direction='left'
              visible={state.visible}

            />
          ) : null
          }


          {state.metaPanelVisible ? (
            <MetaPanelSidebar
              animation='overlay'
              direction='right'
              visible={state.metaPanelVisible}
            />
          ) : null
          }

          {/*  dimmed={state.metaPanelVisible && state.visible}  */}
          <Sidebar.Pusher >
            {/* <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment> */}

            <Container style={{
              minHeight: '100vh',
              border: "0px solid transparent",
              // margin:'auto',
              //  height:200px; width:400px;
              overflow: 'hidden',

            }} >

              {/* {console.log('--------- line 548 ---------')}
              {console.log(currentGroup)} */}

              {/* { currentGroup !== undefined && currentProjectChats !== undefined?( */}

                { currentGroup !== undefined ?(
                <>
            <Chats
                // key={MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ") && "7e6096da-1062-42e1-8799-32dba9a3d7ba"}
                // key={ currentGroup.id} //'7e6096da-1062-42e1-8799-32dba9a3d7ba' && 
                  // key={ currentGroup && currentdGroup.cardId}
                  key={currentGroup.cardId && currentGroup}
                currentGroup={currentGroup}
                logId={currentGroup.logsGroupId}
                // lid={'7e6096da-1062-42e1-8799-32dba9a3d7ba'}
                // oid={'-LwLujWwcsr6szQxZYer'}
                oid = {props.oid}
                currentProjectChats={currentProjectChats}

                // pid={currentProjectChats}
                pid = {currentGroup}
                // changeGroup={changeGroup}
                currentUser={MyStore.auth().currentUser}
                isDM={false}
            />

                          {/* <Messages
                key={currentGroup && currentGroup.id}
                currentGroup={currentGroup}
                currentUser={currentUser}
                isDM={true}
              /> */}
                
                </>
              ) : null }

              



              


            </Container>



          </Sidebar.Pusher>



        </Sidebar.Pushable>

      </div>



      <hr></hr>
     
{/* {    console.log(cards)} */}
    {/* {console.log(groupChats)} */}

   






    </React.Fragment>
  )


}




 



export default ChatView;



 